import { render, staticRenderFns } from "./datiRecord.vue?vue&type=template&id=04b72467&"
import script from "./datiRecord.vue?vue&type=script&lang=js&"
export * from "./datiRecord.vue?vue&type=script&lang=js&"
import style0 from "./datiRecord.vue?vue&type=style&index=0&id=04b72467&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports